import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import React from "react";
import OwlCarousel from "react-owl-carousel";
import SliderImage1 from "../../../assets/images/png/home/individual.webp";

import * as Animate from "react-reveal";
import { Link } from "react-router-dom";
import { africa, europe } from "../../../utils/getStartedSliderData";

const Stats = ({ name, value }) => {
  return (
    <div className="">
      <p className="text-2xl lg:text-3xl font-semibold font-mono">{value}</p>
      <p className="text-sm  lg:text-sm-15">{name}</p>
    </div>
  );
};

const ItemCard = ({ datum }) => {
  return (
    <div className="item w-full flex flex-wrap flex-row justify-between">
      <div className="w-full lg:w-4/12">
        <div className="w-14 lg:w-20">
          <img src={datum?.icon} alt="Icon" />
        </div>
        <div className="mt-4 lg:mt-8">
          <h3 className="text-xl lg:text-2xl xl:text-3xl font-medium font-mono">
            {datum?.title}
          </h3>

          <p className="mt-4 lg:mt-6 text-base lg:text-lg text-default leading-7">
            {datum?.description}
          </p>
          <div className="mt-10 lg:mt-14">
            {datum?.linkUrl?.includes("http") ? (
              <a
                target={"_blank"}
                rel="noopener noreferrer"
                href={datum?.linkUrl || "/"}
                className="flex flex-row items-center font-mono font-medium text-primary hover:text-secondary transition-all ease-in-out text-base lg:text-lg"
              >
                Get Started{" "}
                <span className="pl-4">
                  <svg
                    width="13"
                    height="12"
                    viewBox="0 0 13 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.3101 6.56097C12.6175 6.25358 12.6175 5.7552 12.3101 5.44781L7.30089 0.438603C6.9935 0.131213 6.49513 0.131213 6.18774 0.438603C5.88034 0.745993 5.88034 1.24437 6.18774 1.55176L10.6404 6.00439L6.18774 10.457C5.88035 10.7644 5.88035 11.2628 6.18774 11.5702C6.49513 11.8776 6.9935 11.8776 7.30089 11.5702L12.3101 6.56097ZM0.27063 6.79152L11.7535 6.79152L11.7535 5.21727L0.27063 5.21727L0.27063 6.79152Z"
                      fill="#050794"
                    />
                  </svg>
                </span>
              </a>
            ) : (
              <Link
                to={datum?.linkUrl || "/"}
                className="flex flex-row items-center font-mono font-medium text-primary hover:text-secondary transition-all ease-in-out text-base lg:text-lg"
              >
                Get Started{" "}
                <span className="pl-4">
                  <svg
                    width="13"
                    height="12"
                    viewBox="0 0 13 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.3101 6.56097C12.6175 6.25358 12.6175 5.7552 12.3101 5.44781L7.30089 0.438603C6.9935 0.131213 6.49513 0.131213 6.18774 0.438603C5.88034 0.745993 5.88034 1.24437 6.18774 1.55176L10.6404 6.00439L6.18774 10.457C5.88035 10.7644 5.88035 11.2628 6.18774 11.5702C6.49513 11.8776 6.9935 11.8776 7.30089 11.5702L12.3101 6.56097ZM0.27063 6.79152L11.7535 6.79152L11.7535 5.21727L0.27063 5.21727L0.27063 6.79152Z"
                      fill="#050794"
                    />
                  </svg>
                </span>
              </Link>
            )}
          </div>
        </div>
      </div>
      <div className="mt-8 lg:mt-0 w-full lg:w-7/12 flex flex-col">
        <div className="w-10/12 lg:w-7/12">
          <img src={datum?.image || SliderImage1} alt="" />
        </div>

        <div className="relative -top-20 lg:-top-36 w-10/12 lg:w-7/12 self-end bg-darkgreen rounded-lg py-6 lg:py-10 px-6 lg:px-10 ">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-white">
            {datum?.stats?.map((stat, index) => (
              <Stats key={index} name={stat?.name} value={stat?.value} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const GetStartedSliderSection = ({ selectedLocation }) => {
  return (
    <>
      <section className="relative pt-10 md:pt-10 pb-8 lg:pt-16 md:pb-0">
        <Animate.Fade bottom>
          <div className="container px-4 mx-auto">
            <OwlCarousel
              className="owl-cover owl-theme testimonial-slider"
              items={1}
              loop={true}
              nav={false}
              dots={true}
              autoplay={true}
            >
              {selectedLocation?.name === "Africa" || !selectedLocation ? (
                <>
                  {africa?.map((datum) => (
                    <ItemCard datum={datum} key={datum?.id} />
                  ))}
                </>
              ) : (
                <>
                  {europe?.map((datum) => (
                    <ItemCard datum={datum} key={datum?.id} />
                  ))}
                </>
              )}
            </OwlCarousel>
          </div>
        </Animate.Fade>
      </section>
    </>
  );
};

export default GetStartedSliderSection;
